import styled, { css } from "styled-components";

export const DropdownOptionsContainer = styled.div`
  padding-inline: 47px;
  padding-top: 35px;
`;
export const DropdownOptionsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const DropdownOptionsTitle = styled.div`
   font-weight: 700;
    font-size: 20px;
    color: #464e5f;
    margin: 0;
    font-family: var(--SettingsDropdownOptionsTitleFont-family);
`;
export const DropdownOptionsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;








export const DropdownOptionsContent = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const PaymentGatewayContentName = styled.div`

`

export const PaymentGatewayContentAddName = styled.div`
  height: 48px;
  background-color: #F3F6F9;
  border-color: #F3F6F9;
  color: #3F4254;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  border-radius: 0.42rem;
  display: flex;
  align-items: center;
`
export const PaymentGatewayContentAddNameType = styled.div`
  padding-left: 1.5rem;
  font-size: 14px;
  color: #3F4254;
`
export const PaymentGatewayContentAddNameField = styled.input`
  background: transparent;
  border: none;
  color: #3F4254;
  height: 100%;
  flex: 1;
  padding-right: 1.5rem;
`





export const DropdownOptionsContentForm = styled.div`
  .disabled-dropdown-options {
    opacity: 0.7;
    pointer-events: none;
  }
`


export const DropdownOptionFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DropdownOptionFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DropdownOptionFormFieldsTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
`;